export const generateLabelsW2W = (packages_data, logo, wood_certificates, findTheFontSize) => {
  const noBorders = [false, false, false, false];
  const leftBorders = [true, false, false, false];

  //const certificateItemMargins = [0, 7, 0, 0];
  const separateSymbolMargins = [0, 10, 0, 0];

  const docDefinition = {
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [2, 2, 2, 5],
    content: [],
    defaultStyle: {},
    styles: {
      header: {
        fontSize: 140,
        alignment: 'center',
        lineHeight: 0.8
      },
      subheader: {
        fontSize: 25,
        alignment: 'center'
      },
      subsubheader: {
        fontSize: 25,
        alignment: 'left'
      },
      sizesParamsSeparator: {
        fontSize: 25,
        alignment: 'center'
      },
      sizesParamsName: {
        fontSize: 11,
        alignment: 'center'
      },
      mainParams: {
        fontSize: 37,
        alignment: 'center',
        bold: true
      },
      paramsName: {
        fontSize: 10,
        alignment: 'center'
      },
      paramsValue: {
        fontSize: 18,
        alignment: 'center',
        bold: true
      }
    }
  };
  for (let i = 0; i < packages_data.length; i++) {
    const {package_nr, barcode_img, thickness, width, length, quality_w2w, wood_w2w, pieces, impr_w2w = '-', children} = packages_data[i];
    docDefinition.content.push(
      {
        image: logo,
        width: 318,
        height: 100,
        margin: 5,
        alignment: 'center',
        pageBreak: i !== 0 ? 'before' : null
      },
      {
        columns: [
          {
            margin: [13, 3, 0, 0],
            table: {
              widths: ['62%', '36%'],
              body: [
                [
                  {
                    border: [true, true, false, false],
                    table: {
                      widths: ['33%', '33%', '33%'],
                      body: [
                        [
                          {text: 'EPAIS / DIAM', style: 'paramsName', border: noBorders},
                          {text: 'LARG.', style: 'paramsName', border: noBorders},
                          {text: 'LONG', style: 'paramsName', border: noBorders}
                        ],
                      ]
                    }
                  },
                  {
                    text: 'CERTIFICATION',
                    style: 'paramsName',
                    margin: [0, 3, 0, 0],
                    border: [true, true, true, false]
                  }
                ],
                [
                  {
                    border: leftBorders,
                    table: {
                      widths: ['30%', '5%', '30%', '5%', '30%'],
                      body: [
                        [
                          {text: thickness, border: noBorders, style: 'mainParams'},
                          {
                            text: 'X',
                            style: 'sizesParamsSeparator',
                            border: noBorders,
                            bold: true,
                            margin: separateSymbolMargins
                          },
                          {text: width, border: noBorders, style: 'mainParams'},
                          {
                            text: 'X',
                            style: 'sizesParamsSeparator',
                            border: noBorders,
                            bold: true,
                            margin: separateSymbolMargins
                          },
                          {text: length, border: noBorders, style: 'mainParams'}
                        ],
                        [
                          {text: 'TRAITEMENT', border: noBorders, style: 'paramsName', margin: [0, 25, 0, 0]},
                          {
                            text: '',
                            border: noBorders,
                            bold: true
                          },
                          {text: 'TYPE DE BOIS', border: noBorders, style: 'paramsName', margin: [0, 25, 0, 0]},
                          {
                            text: '',
                            border: noBorders,
                            bold: true
                          },
                          {text: 'QUALITE', border: noBorders, style: 'paramsName', margin: [0, 25, 0, 0]}
                        ],
                        [
                          {text: impr_w2w, border: noBorders, style: 'paramsValue'},
                          {
                            text: '',
                            border: noBorders,
                            bold: true
                          },
                          {text: wood_w2w, border: noBorders, style: 'paramsValue'},
                          {
                            text: '',
                            style: 'sizesParamsSeparator',
                            border: noBorders,
                            bold: true
                          },
                          {text: quality_w2w, border: noBorders, style: 'paramsValue'}
                        ]
                      ]
                    }
                  },
                  {
                    image: wood_certificates,
                    width: 200,
                    height: 120,
                    margin: [0, 5, 0, 10],
                    border: [true, false, true, true],
                    alignment: 'center'
                  }
                ],
                [{text: '', border: leftBorders}, {
                  text: 'PCS',
                  style: 'paramsName',
                  border: [true, false, true, false],
                  margin: [0, 5, 0, 0]
                }],
                [
                  {
                    border: [true, false, true, true],
                    margin: 0,
                    table: {
                      widths: ['25%', '75%'],
                      body: [
                        [{
                          text: `NUMERO
                          DE COLIS`,
                          style: 'paramsName',
                          border: noBorders,
                          margin: [5, 30, 5, 0]
                        },
                          {
                            border: noBorders,
                            table: {
                              body: [
                                [{text: package_nr || '-', border: noBorders, style: 'mainParams'}],
                                [
                                  {
                                    image: barcode_img,
                                    width: 200,
                                    height: 40,
                                    margin: [0, 2, 0, 0],
                                    border: noBorders,
                                    alignment: 'center'
                                  }
                                ]
                              ]
                            }
                          }
                        ],
                      ]
                    }
                  },
                  {
                    text: pieces,
                    style: 'mainParams',
                    border: [true, false, true, true],
                    margin: [0, 25, 0, 0]
                  }
                ]
              ]
            }
          }
        ]
      }
    );
    if (children && children.length > 0) {
      const table = {
        pageBreak: 'before',
        margin: [5, 15, 5, 5],
        table: {
          widths: [570],
          body: [
            [{
              text: package_nr,
              style: 'subheader',
              margin: [5, 15, 5, 15],
              border: noBorders
            }]
          ]
        }
      };
      for (let j = 0; j < children.length; j++) {
        table.table.body.push([{
          text: children[j],
          style: 'subsubheader',
          border: [true, true, true, true]
        }]);
      }
      docDefinition.content.push(table);
    }
  }
  findTheFontSize(docDefinition);
  return docDefinition;
};



// WEBPACK FOOTER //
// ./src/helpers/pdf-labels/labels-w2w.js